module.exports = __webpack_public_path__ + "img/arrow-toggler-bottom-icon.bb5454ed.svg";